module.exports = __webpack_public_path__ + "static/media/OnScreenText_2.fedd9608.gif";